import { useParams } from 'react-router-dom'

export default function ComplianceDocumentDetail() {
  const { slug } = useParams<{ slug: string }>()

  return (
    <div className="w-full p-6">
      <h1 className="text-2xl font-semibold mb-2">
        Document · <code>{slug}</code>
      </h1>
      <p className="text-muted-foreground">
        TipTap editor + version history + publish-preview modal ship in D2.
      </p>
    </div>
  )
}
